/**
 * Comparison Data: Evminov Board vs Inversion Tables vs Spinal Surgery
 */

export const comparisonData = {
  title: 'Why Doctors & Athletes Choose Evminov Over Inversion Tables',
  subtitle: 'Full spinal decompression under controlled angles (8°–35°) without dangerous blood rush or ankle pressure.',
  rows: [
    {
      metric: 'Traction Mechanism',
      evminov: {
        value: 'Controlled inclined plane (8°–35°)',
        highlight: true,
        note: 'Smooth physiological decompression matched to your body weight',
      },
      inversion: {
        value: 'Hanging upside down (up to 90° inverted)',
        highlight: false,
        note: 'Aggressive gravitational pull with zero fine-tuning',
      },
      surgery: {
        value: 'Invasive bone / disc resection (Microdiscectomy)',
        highlight: false,
        note: 'Permanent alteration of spinal anatomy',
      },
    },
    {
      metric: 'Back & Core Support',
      evminov: {
        value: 'Full anatomical pine board support',
        highlight: true,
        note: 'Natural wood flex cushions discs while preventing hyper-extension',
      },
      inversion: {
        value: 'Zero spinal support (body hangs unsupported)',
        highlight: false,
        note: 'Can aggravate lumbar hyper-lordosis and sacroiliac strain',
      },
      surgery: {
        value: 'Post-operative tissue scarring & weakness',
        highlight: false,
        note: 'Requires 6–12 months of immobilization & physical rehab',
      },
    },
    {
      metric: 'Cardiovascular & Eye Pressure',
      evminov: {
        value: '0% blood rush (Safe for blood pressure)',
        highlight: true,
        note: 'Head stays above or level with torso; safe for seniors & glaucoma',
      },
      inversion: {
        value: 'DANGEROUS blood pressure spike',
        highlight: false,
        note: 'Contraindicated for hypertension, glaucoma, heart disease, retinal issues',
      },
      surgery: {
        value: 'General anesthesia risks & infection',
        highlight: false,
        note: 'Hospital stay risks and potential nerve damage',
      },
    },
    {
      metric: 'Ankle & Knee Joint Strain',
      evminov: {
        value: 'Zero ankle strain (Arms or soft foot holders)',
        highlight: true,
        note: 'Body weight is distributed across the full length of the pine board',
      },
      inversion: {
        value: 'Severe crushing ankle clamp pressure',
        highlight: false,
        note: 'Entire body weight hangs from delicate ankle and knee joints',
      },
      surgery: {
        value: 'N/A',
        highlight: false,
        note: 'Does not affect ankle joints directly',
      },
    },
    {
      metric: 'Muscle Strengthening',
      evminov: {
        value: 'Active rehabilitation (Trains deep erectors)',
        highlight: true,
        note: 'Strengthens short intervertebral muscles while under gentle stretch',
      },
      inversion: {
        value: 'Purely passive hanging (No muscle building)',
        highlight: false,
        note: 'Does not train spinal stabilizing core muscles',
      },
      surgery: {
        value: 'Muscle atrophy from surgical incision',
        highlight: false,
        note: 'Deep paraspinal muscles are cut through and weakened',
      },
    },
    {
      metric: 'Home Space Footprint',
      evminov: {
        value: 'Folds flat to wall (Only 2.4 inches deep)',
        highlight: true,
        note: 'Takes practically zero room floor space when stored',
      },
      inversion: {
        value: 'Huge steel A-frame (Takes 15+ sq ft)',
        highlight: false,
        note: 'Clunky, heavy steel contraption that dominates living rooms',
      },
      surgery: {
        value: 'N/A (Hospital setting)',
        highlight: false,
        note: 'Takes no home space, but requires extensive hospital time',
      },
    },
    {
      metric: 'Clinical Track Record & Heritage',
      evminov: {
        value: 'Continuous clinical practice since 1996 (30 Years)',
        highlight: true,
        note: 'Over 500,000 patients healed across 30 years and 7 defended medical dissertations',
      },
      inversion: {
        value: 'Non-medical gym novelty with zero clinical trials',
        highlight: false,
        note: 'Designed for consumer fitness market without clinical hospital protocols',
      },
      surgery: {
        value: 'Invasive last resort with 20%–40% recurrence rate',
        highlight: false,
        note: 'Frequent post-laminectomy syndrome and adjacent segment disease',
      },
    },
    {
      metric: 'Total Cost',
      evminov: {
        value: '$450 – $595 (One-time, with 10-Yr Warranty)',
        highlight: true,
        note: 'HSA/FSA Eligible • Klarna 4 x $112.50 interest-free',
      },
      inversion: {
        value: '$450 – $850 (Teeter / IronMan)',
        highlight: false,
        note: 'Requires replacement ankle foam & ongoing maintenance',
      },
      surgery: {
        value: '$45,000 – $120,000+',
        highlight: false,
        note: 'Massive insurance co-pays, deductibles, and lost wages',
      },
    },
  ],
};
